import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, ArrowUpRight, Linkedin } from "lucide-react";
import { COMPANY } from "@/data/content";

const cols = [
  { title: "Company", links: [["About", "/about"], ["Services", "/services"], ["Careers", "/careers"]] },
  { title: "Explore", links: [["Machines for Sale", "/machines"], ["Clients", "/clients"], ["Gallery", "/gallery"], ["FAQs", "/faq"]] },
  { title: "Support", links: [["Contact", "/contact"], ["Enquiry", "/enquiry"], ["Request a Quote", "/quote"], ["Privacy Policy", "/privacy"]] },
];

export const Footer = () => (
  <footer className="relative border-t border-slate-200 bg-slate-50" data-testid="footer">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-14 pb-8">
      {/* Top: Brand + Map */}
      <div className="grid lg:grid-cols-[1.15fr_1fr] gap-10 pb-12 border-b border-slate-200">
        <div>
          <div className="flex items-center gap-3">
            <img src={COMPANY.logo} alt="Accurate" className="h-12 w-auto rounded-md" data-testid="footer-logo" />
            <div>
              <p className="font-display text-xl leading-tight text-slate-900">Accurate <span className="text-[#0055FF]">Automation &amp; Reconditioners</span></p>
              <p className="text-xs text-slate-500 mt-0.5">Precision CNC · Retrofitting · Reconditioning</p>
            </div>
          </div>
          <div className="mt-5 space-y-2 text-sm">
            <a href={`tel:${COMPANY.officePhone}`} className="flex items-center gap-2.5 text-slate-700 hover:text-slate-900 transition-colors"><Phone className="w-4 h-4 text-[#0055FF]" /> Office: {COMPANY.officePhone}</a>
            <a href={`tel:${COMPANY.phone}`} className="flex items-center gap-2.5 text-slate-700 hover:text-slate-900 transition-colors"><Phone className="w-4 h-4 text-[#0055FF]" /> Phone: {COMPANY.phone}</a>
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2.5 text-slate-700 hover:text-slate-900 transition-colors"><Mail className="w-4 h-4 text-[#0055FF]" /> {COMPANY.email}</a>
            <p className="flex items-start gap-2.5 text-slate-700"><MapPin className="w-4 h-4 text-[#0055FF] mt-0.5 shrink-0" /> {COMPANY.address}</p>
            <p className="flex items-start gap-2.5 text-slate-700"><Clock className="w-4 h-4 text-[#0055FF] mt-0.5 shrink-0" /> {COMPANY.hours}</p>
          </div>
          <a href={COMPANY.linkedin} target="_blank" rel="noopener noreferrer"
            className="mt-5 inline-flex items-center gap-2 text-sm text-slate-700 hover:text-[#0055FF] transition-colors"
            data-testid="footer-linkedin">
            <Linkedin className="w-4 h-4" /> Follow us on LinkedIn
          </a>
        </div>

        {/* Map */}
        <div className="rounded-xl overflow-hidden border border-slate-200 h-64 lg:h-full min-h-[240px]" data-testid="footer-map-wrap">
          <iframe title="Accurate Automation and Reconditioners — location" src={COMPANY.mapEmbed} width="100%" height="100%" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="footer-map" />
        </div>
      </div>

      {/* Link columns */}
      <div className="grid md:grid-cols-3 gap-8 pt-10">
        {cols.map((col) => (
          <div key={col.title}>
            <h4 className="text-[11px] uppercase tracking-[0.2em] text-slate-500 mb-4">{col.title}</h4>
            <ul className="space-y-2.5">
              {col.links.map(([label, to]) => (
                <li key={to}>
                  <Link to={to} className="group inline-flex items-center gap-1 text-sm text-slate-700 hover:text-slate-900 transition-colors" data-testid={`footer-link-${to}`}>
                    {label}
                    <ArrowUpRight className="w-3 h-3 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-10 pt-6 border-t border-slate-200 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="text-xs text-slate-500">© {new Date().getFullYear()} {COMPANY.legal}. All rights reserved.</p>
        <div className="flex items-center gap-5 text-xs text-slate-500">
          <Link to="/privacy" className="hover:text-slate-900 transition-colors">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-slate-900 transition-colors">Terms &amp; Conditions</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
